export const terminalTypeOptions = [
  'EDSQ',
  'Flex',
  'Game Touch 20',
  'Game Touch 28',
  'Gemini',
  'GT1200',
];